import { SelectOption } from '@kanda-libs/ks-component-ts';

import { ApplyFormFieldValues } from 'pages/Apply/context';

import { YEARS_AT_ADDRESS_INDEXES } from './constants';

import { AddressFieldType } from '..';

export const generateYearsOptions = (): SelectOption[] => {
  const now = new Date();
  const year = now.getFullYear();
  return Array.from(Array(100).keys(), (value: number) => ({
    name: `${year - value}`,
    value: `${year - value}`,
  }));
};

export const getTime = (years?: string, months?: string): number => {
  if (!years || !months) return -1;
  const now = new Date();
  const monthsDiff = now.getMonth() - parseInt(months, 10);
  const yearsDiff = now.getFullYear() - parseInt(years, 10);
  return yearsDiff * 12 + monthsDiff;
};

export const checkInPast = (
  values: ApplyFormFieldValues,
  addressType: AddressFieldType,
): boolean => {
  const index = YEARS_AT_ADDRESS_INDEXES[addressType];
  const months = values?.address?.[index]?.month_moved_in;
  const years = values?.address?.[index]?.year_moved_in;
  const time = getTime(years, months);
  return time >= 0;
};

export const checkBeforePrevAddress = (
  values: ApplyFormFieldValues,
  addressType: AddressFieldType,
) => {
  const index = YEARS_AT_ADDRESS_INDEXES[addressType];
  if (index === 0) return true;
  const prevMonths = values?.address?.[index - 1]?.month_moved_in;
  const prevYears = values?.address?.[index - 1]?.year_moved_in;
  const currentMonths = values?.address?.[index]?.month_moved_in;
  const currentYears = values?.address?.[index]?.year_moved_in;
  const previousTime = getTime(prevYears, prevMonths);
  const currentTime = getTime(currentYears, currentMonths);
  return currentTime > previousTime;
};
